import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import EmptyData from "../../../components/emptyData";
import LineChart from "../../../components/lineChart";
import ModalLoading from "../../../components/modalLoading";
import PieChart from "../../../components/pieChart";
import SelectBox from "../../../components/selectBox";
import ToggleButton from "../../../components/toggleButton";
import LayoutDashboard from "../../../layouts/dashboard";
import { headers } from "../../../utils/callApi";
import { getListProjectOfUser } from "../../manageUser/service";
import { getDataFile, getDataStorage } from "../redux/action";
import './index.css';

const GB_TO_BYTE = 1073741824;

function DashboardStorage() {
  const account = useSelector((state) => state.account.account);

  const [page, setPage] = useState(1); //1: Dung lượng đã dùng, 2: Tổng file đã upload

  const initProject = async () => {
    let {success, data} = await getListProjectOfUser(1);
    const result = data.map((pr) => {
      return {
        api_key: pr.api_key,
        name: pr.account_name,
        checked: true,
      }
    });
    return result;
  };

  const [project, setProject] = useState([]);

  useEffect(() => {
    initProject().then((result) => {
      setProject(result);
    })
  },[headers]);

  let d1 = new Date();
  d1.setDate(d1.getDate() - 60);
  const [fromDate, setFromDate] = useState(d1);

  let d2 = new Date();
  d2.setDate(d2.getDate() - 1);
  const [toDate, setToDate] = useState(d2);

  const [typeTime, setTypeTime] = useState(1); //1: Ngày, 2: Tháng

  const dispatch = useDispatch();
  const [
    isGettingDataStorage,
    isGottenDataStorageSuccess,
    isGottenDataStorageNotFound,
    isGottenDataStorageFail,
    dataStorage
  ] = useSelector((state) => [
    state.dashboardStorage.isGettingDataStorage,
    state.dashboardStorage.isGottenDataStorageSuccess,
    state.dashboardStorage.isGottenDataStorageNotFound,
    state.dashboardStorage.isGottenDataStorageFail,
    state.dashboardStorage.dataStorage
  ]);

  const [
    isGettingDataFile,
    isGottenDataFileSuccess,
    isGottenDataFileNotFound,
    isGottenDataFileFail,
    xdataFile,
    ydataFile,
  ] = useSelector((state) => [
    state.dashboardStorage.isGettingDataFile,
    state.dashboardStorage.isGottenDataFileSuccess,
    state.dashboardStorage.isGottenDataFileNotFound,
    state.dashboardStorage.isGottenDataFileFail,
    state.dashboardStorage.xdataFile,
    state.dashboardStorage.ydataFile,
  ]);


  const clickSelectBox = (index) => {
    const temp = [...project];
    temp[index].checked = project[index].checked ? false : true;
    setProject(temp);
  }

  const clickAllProject = (checked) => {
    const temp = [...project];
    temp.forEach((e) => {
      e.checked = checked;
    })
    setProject(temp);
  }

  function changeDate(start, end) {
    const today = new Date();
    let yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    if(start < today) {
      setFromDate(start);
    } else {
      setFromDate(yesterday);
    }

    if( end < today) {
      setToDate(end);
    } else {
      setToDate(yesterday);
    }
    if(typeTime === 1){
      const diffTime = Math.abs(start - end);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if(diffDays > 60) {
        setFromDate(d1);
        setToDate(d2);
      }
    }
  }

  const changeDateToString = (date) => {
    if(typeTime === 1){
      return ("0" + date.getDate()).slice(-2) + "/" + ("0" + (date.getMonth() + 1)).slice(-2) + "/" +date.getFullYear();
    } else {
      return ("0" + (date.getMonth() + 1)).slice(-2) + "/" +date.getFullYear()
    }
    
  }

  useEffect(() => {
    if(page === 1) {
      const temp = [...project];
      temp.forEach((e) => {
        e.checked = true;
      })
      setProject(temp);
    } else {
      const temp = [...project];
      temp.forEach((e) => {
        e.checked = false;
      })
      setProject(temp);
    }
  }, [page])

  useEffect(() => {
    if(page === 1) {
      const params= [];
      project.map((pr) => {
        if(pr.checked){
          params.push(pr.name);
        }
      })
      dispatch(getDataStorage({
        name: params
      }))
    } else {
      const projects = [];
      project.map((pr) => {
        if(pr.checked){
          projects.push(pr.name);
        }
      });
      const query_by_date = (typeTime === 1);
      let from_date, to_date;
      if(query_by_date) {
        from_date = fromDate.getFullYear() + '-' + ("0" + (fromDate.getMonth() + 1)).slice(-2) + '-' + ("0" + fromDate.getDate()).slice(-2);
        to_date = toDate.getFullYear() + '-' + ("0" + (toDate.getMonth() + 1)).slice(-2) + '-' + ("0" + toDate.getDate()).slice(-2);
      } else {
        from_date = fromDate.getFullYear() + '-' + ("0" + (fromDate.getMonth() + 1)).slice(-2) + '-' + '01';
        to_date = toDate.getFullYear() + '-' + ("0" + (toDate.getMonth() + 1)).slice(-2) + '-' + ("0" + toDate.getDate()).slice(-2);
      }

      dispatch(getDataFile({
        projects,
        query_by_date,
        from_date,
        to_date,
      }))
    }
  },[project, toDate]);

  return (
    <>
      <LayoutDashboard activeIndex={1}>
        <div className="main_dashboard">
          <div className="el_dashboard_1">
            <ToggleButton 
              button1 = 
              {{
                name: 'Dung lượng đã dùng',
                onClick: () => {setPage(1)},
              }} 
              button2=
              {{
                name: 'Tổng file đã upload',
                onClick: () => {setPage(2)},
              }}></ToggleButton>
          </div>
          <div className="el_dashboard_2">
            <SelectBox 
              projects={project}
              handleChecked={
                (index) => clickSelectBox(index)
              }
              handleCheckAllProject={
                (checked) => clickAllProject(checked)
              }
            ></SelectBox>
          </div>
          <div className="el_dashboard_3">
            {page === 2 &&
            <ToggleButton 
              button1 = 
              {{
                name: 'Ngày',
                onClick: () => {setTypeTime(1);},
              }} 
              button2=
              {{
                name: 'Tháng',
                onClick: () => {setTypeTime(2);},
              }}
              datePick={{
                fromDate: fromDate,
                toDate: toDate,
              }}
              isDatePicker={true}
              handleChangeDate={changeDate}
              flex='right'
            >
            </ToggleButton>
            }
            
          </div>
        </div>
        <div className="main_content">
          {page === 1 ? 
          <>
          {isGottenDataStorageFail && <EmptyData title="Lấy dữ liệu thất bại"></EmptyData>}
          {(dataStorage && dataStorage.length !== 0) ?
          <Container>
            <Row>
              {dataStorage.map((element, index) =>{
                const temp = [
                  {
                    name: "Đã dùng: " + ((element.storage_use / element.storage_size) * 100).toFixed(1) + '%',
                    y: element.storage_use
                  },
                  {
                    name: "Còn trống: " + (((element.storage_size - element.storage_use) / element.storage_size)*100).toFixed(1) + '%',
                    y: element.storage_size - element.storage_use
                  }
                ];
                
                return (
                  <Col key={index} xs={12} sm={6} md={4}>
                    <PieChart title={`Project: ${element.account_name}<br/>Dung lượng: ${(element.storage_size/GB_TO_BYTE).toFixed(2)} GB`} data={temp}></PieChart>
                  </Col>
                )
              })}
            </Row>
          </Container> :
          <>
          {isGottenDataStorageNotFound && <EmptyData title="Không có dữ liệu"></EmptyData> }
          </>
          }
          </> :
          <div className="line-chart">
            {isGottenDataFileNotFound && <EmptyData title="Vui lòng chọn dự án"></EmptyData> }
            {isGottenDataFileFail && <EmptyData title="Lấy dữ liệu thất bại"></EmptyData>}
            {(isGottenDataFileSuccess && xdataFile && dataStorage.length !== 0 && ydataFile && ydataFile.length !== 0) &&
              <LineChart title={(typeTime === 1 ? 'Ngày:' : 'Tháng: ') + `${changeDateToString(fromDate)} - ${changeDateToString(toDate)}`} xdata={xdataFile} ydata={ydataFile}></LineChart>
            }
          </div>
          }
        </div>
      </LayoutDashboard>

      <ModalLoading show={isGettingDataStorage || isGettingDataFile} content={'Đang lấy dữ liệu...'}></ModalLoading>
    </>
  )
}

export default DashboardStorage;